// User/Logo.tsx
import React from 'react';
import logo from '../../Static/img/landing/logo-life-help.svg';
import {useMediaQuery} from "@mui/material";
// Предполагается, что FC — это ваш собственный компонент из "WideLayout/Layouts"
import {FC} from "WideLayout/Layouts";

interface LogoProps {
    height: string | number;
    width?: string | number;
    className?: string;
    onClick?: () => void;
}

const Logo: React.FC<LogoProps> = ({height, width, className, onClick}) => {
    const isGt1630 = useMediaQuery('(min-width: 1630px)');
    const isLt380 = useMediaQuery('(max-width: 380px)');
    const url = window.location.href;
    const logoLow = url.includes('conference')
    // Определяем масштаб и смещение на основе shouldScale
    const scaleValue = logoLow ? '2.5' : isGt1630 ? '2.5' : isLt380 ? '1' : '1.5';
    const translateValue = logoLow ? '2px, 1px' : isGt1630 ? '20px, 10px' : isLt380 ? '0, 1px' : '2px, 1px';

    return (
        <FC pos={'relative'}>
            <img src={logo}
                 onClick={onClick}
                 style={{
                     zIndex: 9,
                     height: height,
                     width: width ? width : 'unset',
                     filter: 'contrast(1.2) brightness(1.3)',
                     transform: `scale(${scaleValue}) translate(${translateValue})`
                 }}
                 className={`${className} logo d-inline-block align-top rounded-2 object-fit-cover`}
                 alt="Помощь психолога"/>
            <img
                src={logo}
                onClick={onClick}
                style={{
                    zIndex: 10,
                    position: 'absolute',
                    top: 0, left: 0,
                    opacity: '0.2',
                    height: height,
                    width: width ? width : 'unset',
                    filter: 'blur(17px) contrast(1.5) brightness(2.3)',
                    transform: `scale(${scaleValue}) translate(${translateValue})`
                }}
                className={`${className} logo d-inline-block align-top rounded-2 object-fit-cover`}
                alt="Logo"
            />
        </FC>
    );
};

export default Logo;
